import React from 'react'

class InputField extends React.Component{

	render(){	
		const {value,onChangeFunction,onBlurFunction,id,placeholder,maxLength,autoFocus,onFocus,onKeyDown} = this.props
		var isEmpty = true
		if (value!==''){
			isEmpty = false
		} 

		return(
			<input	
				autoFocus={autoFocus}	
				onFocus={onFocus}		  
				onKeyDown={onKeyDown}
				type='text'					
				className={"inputField" + (isEmpty ? " is--empty" : " is--nonEmpty")}			      
				placeholder={placeholder}
				value={value}
				maxLength={maxLength}
				onChange={onChangeFunction}
				onBlur={onBlurFunction ? onBlurFunction : null}
				id={id ? id : null}
			/>
		)
	}
				
}



export default InputField


